import { configureStore } from '@reduxjs/toolkit';
import counterReducer from './container/authSlice';
import languageReducer from "../service/context/languageSlice";
import sidebarReducer from "./container/sidebarSlice"
import bookingFormReducer from "./container/formSlice"
import bookingDraftReducer from "./container/draftFormSlice"
import tripBookingReducer from "./container/tripBookingSlice"
import { TypedUseSelectorHook, useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';

export const store = configureStore({
  reducer: {
    counter: counterReducer, 
    language: languageReducer,
    sidebar: sidebarReducer,
    bookingForm: bookingFormReducer,
    tripBooking: tripBookingReducer,
    bookingDraftForm: bookingDraftReducer,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
